import http from 'axios'
import config from 'src/config'

export default store => {
  // Setup the http interceptor
  http.interceptors.request.use(config => {
    const token = store.getState().auth.token
    const newConfig = Object.assign({}, config)

    // We set Authorization to null to bypass
    if (newConfig.headers.Authorization === null) {
      delete newConfig.headers.Authorization
    } else if (!newConfig.headers.Authorization && token) {
      newConfig.headers.Authorization = `bearer ${token}`
    }

    return newConfig
  })

  http.defaults.baseURL = `${config.api.portal}/`
}



// WEBPACK FOOTER //
// ./src/app/init/initHttp.js